import React from 'react';
import { Section } from './ui/Section';
import { Leaf } from 'lucide-react';
export function WhatMakesDifferent() {
  return <Section data-id="element-179">
      <div className="max-w-4xl mx-auto text-center" data-id="element-180">
        <h2 className="text-3xl md:text-5xl font-bold mb-8 text-primary-dark" data-id="element-181">
          What Makes This Guide Different?
        </h2>

        <p className="text-xl text-charcoal/80 mb-8" data-id="element-182">
          There is plenty of supplement information online… But most of it is
          scattered, confusing, overly technical, or designed to sell you more
          products.
        </p>

        <div className="bg-primary/5 border border-primary/10 p-8 md:p-12 rounded-3xl relative overflow-hidden" data-id="element-183">
          <Leaf className="absolute -top-10 -right-10 text-primary/5" size={200} data-id="element-184" />

          <p className="text-2xl font-serif text-primary-dark mb-6 relative z-10" data-id="element-185">
            This guide is different because it is designed to help you use
            supplements smarter.
          </p>

          <p className="text-lg text-charcoal/80 mb-8 relative z-10" data-id="element-186">
            It brings together the most practical information in one place, so
            you can quickly understand:
          </p>

          <div className="flex flex-wrap justify-center gap-3 mb-8 relative z-10" data-id="element-187">
            {['Timing', 'Absorption', 'Synergies', 'Antagonisms', 'Quality', 'Routine Building'].map((tag, i) => <span key={i} className="px-5 py-2 bg-white text-primary font-semibold rounded-full shadow-sm border border-sage-light/30" data-id="element-188">
                {tag}
              </span>)}
          </div>

          <p className="text-xl font-medium text-primary-dark relative z-10" data-id="element-189">
            It’s simple enough for beginners, but valuable enough for anyone
            serious about improving their health habits.
          </p>
        </div>
      </div>
    </Section>;
}